// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateGuatemalanDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  }
  const eightDigitsRegex = /\d{8}/;
  if (!eightDigitsRegex.test(document)) {
    return { id: 'invalid-ci-pattern' };
  }
}
